import React, {useEffect, useState} from 'react';
import { MdSearch, MdHouse, MdShoppingBag, MdWhatsapp} from 'react-icons/md';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

function Navbar(){

   let navigate = useNavigate(); 
   const { cart } = useSelector(state => state.cart);
   const totalItems = cart.reduce((total,item) => total + item.quantity,0) 

   return(
    <div className='flex width-100 navbar'>
      <div className='flex one center'>
          <MdHouse size={25} className='brown' onClick={()=>{navigate('/')}}/>
      </div>
      <div className='flex one center'>
          <MdWhatsapp size={25} className='brown' onClick={()=>{navigate('/chat')}}/>
      </div>
      <div className='flex one center'>
          <MdShoppingBag size={25} className='brown' onClick={()=>{navigate('/cart')}}/>
           <span className='cart-num'>{totalItems}</span> 
      </div>
    </div>
   )
}

export default Navbar